import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Clear } from '@material-ui/icons';
import { CSSTransition } from 'react-transition-group';
import styles from './styles/styles.module.scss';
import LinkDropdown from '../shared/LinkDropdown';
import MainButton from '../shared/MainButton';

class SideDrawer extends Component {
  constructor(props) {
    super(props);
  }

  renderDropdownLinks = () => {
    return this.props.dropdownLinks.map(linkProps => {
      return <LinkDropdown key={linkProps.label} {...linkProps} data-test-id={linkProps.label} />;
    });
  };

  renderHelpAndDownload() {
    return this.props.links.map(link => {
      return (
        <a key={link.label} title={link.label} href={link.linkPath} className={styles.helpDownloadLinks} data-test-id={link.label}>
          {link.label}
        </a>
      );
    });
  }

  renderSignInAndLoginButtons() {
    const { login, signup } = this.props.user;

    return (
      <div className={styles.sideDrawerButtons}>
        <MainButton path={signup.linkPath} text={signup.label} />
        <MainButton type="outline" path={login.linkPath} text={login.label} />
      </div>
    );
  }

  renderProButton() {
    const { proButton } = this.props;

    return (
      <div className={styles.sideDrawerButtons} data-test-id={proButton.label}>
        <MainButton path={proButton.linkPath} text={proButton.label} />
      </div>
    );
  }

  renderCtaButtons() {
    if (!this.props.user.display) {
      return this.renderSignInAndLoginButtons();
    }
    if (this.props.proButton.display) {
      return this.renderProButton();
    }
  }

  render() {
    return (
      <>
        <CSSTransition
          in={this.props.isOpen}
          classNames={{
            enterDone: styles.slideNavigationEnterDone,
            exitDone: styles.slideNavigationExitDone
          }}
          timeout={0}
        >
          <div className={styles.drawerContainer}>
            <a href="#" onClick={this.props.toggleIsOpen} className={styles.exitButton}>
              <Clear className={styles.navigationMenu} />
            </a>
            <div className={styles.linkHeadersContainer}>{this.renderDropdownLinks(this.props.dropdownLinks)}</div>
            <div className={styles.helpAndDownloadContainer}>{this.renderHelpAndDownload()}</div>
            {this.renderCtaButtons()}
          </div>
        </CSSTransition>
        <CSSTransition
          in={this.props.isOpen}
          classNames={{
            enter: styles.opacCoverEnter,
            enterDone: styles.opacCoverEnterDone,
            exit: styles.opacCoverExit,
            exitDone: styles.opacCoverExitDone
          }}
          timeout={100}
        >
          <div className={styles.opacCover} onClick={this.props.toggleIsOpen} />
        </CSSTransition>
      </>
    );
  }
}

SideDrawer.defaultProps = {
  dropdownLinks: [],
  links: [],
  user: {},
  isAdminUser: false
};

SideDrawer.propTypes = {
  user: PropTypes.shape({
    name: PropTypes.string,
    linkPath: PropTypes.string,
    imagePath: PropTypes.string,
    reputation: PropTypes.number,
    display: PropTypes.bool,
    login: PropTypes.shape({
      label: PropTypes.string,
      linkPath: PropTypes.string
    }),
    signup: PropTypes.shape({
      label: PropTypes.string,
      linkPath: PropTypes.string
    })
  }),
  proButton: PropTypes.shape({
    label: PropTypes.string,
    linkPath: PropTypes.string,
    display: PropTypes.bool
  }),
  dropdownLinks: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      linkPath: PropTypes.string,
      dropdown: PropTypes.arrayOf(
        PropTypes.shape({
          label: PropTypes.string,
          linkPath: PropTypes.string
        })
      )
    })
  ),
  links: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      linkPath: PropTypes.string
    })
  )
};

export default SideDrawer;
